import { render, staticRenderFns } from "./AppOverview.vue?vue&type=template&id=52dfa998&scoped=true"
import script from "./AppOverview.vue?vue&type=script&lang=js"
export * from "./AppOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dfa998",
  null
  
)

export default component.exports